import React from 'react';
import  { useState, useRef, useCallback } from 'react';
import  { useEffect }from 'react';
import  { 
    useMemo,
  
    StrictMode, } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import ListItemButton from '@mui/material/ListItemButton';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from "./redux/actions"

import { useNavigate } from "react-router-dom";

import { APIvar } from '../services/variables';
import styles from './TelefonskiImenik.module.css'
import { componentStyles } from '../services/elementDesign'

import { APICall } from './services/api.service';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AllCommunityModule } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";


import { useSearchParams } from "react-router-dom";




import {
    ClientSideRowModelModule,
    ColumnApiModule,
    ColumnAutoSizeModule,
    ModuleRegistry,
    ValidationModule,
    createGrid,
    themeQuartz,
    themeBalham,

    RowSelectionModule,
    RowApiModule,
    RowStyleModule,
    TextEditorModule


} from "ag-grid-community";




import { styled } from "@mui/material/styles";


const MyTextField = styled(TextField)(() => ({
  ".MuiInputBase-input.Mui-disabled": {
    WebkitTextFillColor: "black",
    color: "black"
  }
}));
  
  
ModuleRegistry.registerModules([
    RowSelectionModule,
    ClientSideRowModelModule,


    ValidationModule,
    ColumnApiModule,
    ColumnAutoSizeModule,
    RowApiModule,
    RowStyleModule,
    TextEditorModule 
    
]);
  
  
  


  const myTheme = themeBalham.withParams({
    headerHeight: "30px",
    headerTextColor: "black",
    headerBackgroundColor: "#99ABCD",
    headerCellHoverBackgroundColor: "rgba(80, 40, 140, 0.66)",
    headerCellMovingBackgroundColor: "rgb(80, 40, 140)",
    selectedRowBackgroundColor: '#8386a6',
    //fontSize: 16,
    fontWeight:400

  });

const theme = createTheme({
    palette: {
        primary: {
            main: '#520074'
        }
    },
    mixins: {
        MuiDataGrid: {
          // Pinned columns sections
          pinnedBackground: '#520074',
          // Headers, and top & bottom fixed rows
          containerBackground: 'primary',
        },
      },

});


const useColor = APIvar.colorUse;
const thirdColor = APIvar.colorTerciary;
const backColor = APIvar.colorBackground;
const cardBackColor = APIvar.cardBackgrounColor;

document.documentElement.style.setProperty('--backColor', backColor);
document.documentElement.style.setProperty('--cardBackColor', cardBackColor);




const TelefonskiImenik = () => {


    const themeAG = useMemo(() => {
        return myTheme;
    }, []);

/*****************************************************TEZINE GRID**************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */

const [companyList, setCompanyList] = useState([],[]);
const [showCompanyList, setShowCompanyList] = useState(false);
const [selectedComp, setSelectedComp] = useState([]);

    const gridRef_Comp = useRef();
    const containerStyle_Comp = useMemo(() => ({ width: "100%", height: "100%" }), []);
    const gridStyle_Comp = useMemo(() => ({ height: "100%", width: "100%" }), []);



    const autoSizeStrategy_Comp = useMemo(() => {
        return {
          type: "fitCellContents",
          skipHeader : false
        };
      }, []);

      const autoSizeAll_Comp = useCallback((skipHeader) => {
        const allColumnIds = [];
        gridRef_Comp.current.api.getColumns().forEach((column) => {
          allColumnIds.push(column.getId());
        });
        gridRef_Comp.current.api.autoSizeColumns(allColumnIds, skipHeader);
      }, []);


      const onGridReady_Comp = useCallback((event) => {
        console.log("Grid ready *********************************************************************************")
        let nodes = event.api.getRenderedNodes();
        autoSizeAll_Comp();
        if (nodes.length) {
          //nodes[0].setSelected(true); //selects the first row in the rendered view
          //nodes[1].setSelected(true);
        }
      }, []);

      const selectAll_Comp = useCallback((event) =>{
            console.log("I wanna select it all!!!!!");

            event.api.selectAll();
            console.log("Selected");
      }, []);

      const onColumnResized_Comp = useCallback((params) => {
        console.log(params);
      }, []);

      const themeAG_Comp = useMemo(() => {
        return myTheme;
      }, []);
    

    const onSelectionChanged_Comp = useCallback((event) => {

        
        
        let selectedData=[]
    

        
        for(var i=0; i<event.api.getSelectedNodes().length; i++) {


            selectedData.push(event.api.getSelectedNodes()[i].data);

        }
        
        
        setSelectedComp(selectedData);

        console.log("Selecteeeed");
        console.log(selectedData);
  

    
    
    }, []);





/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */





    const token = localStorage.getItem("token");


    const navigate = useNavigate();

    const [isLoading, setLoading] = useState(false);
    const dispatch = useDispatch()

    const [sifraFirme, setSifraFirme] = useState('');
    const [pojam, setPojam] = useState('')
    const [mjesto, setMjesto] = useState('')
    const [nazivFirme, setNazivFirme] = useState('')
    const [nazivStru, setNazivStru] = useState('')
    const [matBroj, setMatBroj] = useState('')
    const [kbrSlovo1, setKbrSlovo1] = useState('')
    const [tel2, setTel2] = useState('')
    const [ulica, setUlica] = useState('')
    const [tel1, setTel1] = useState('')
    const [kbrSlovo2, setKbrSlovo2] = useState('')
    const [kbr2, setKbr2] = useState('')
    const [oib, setOib] = useState('')
    const [djelatnost, setDjelatnost] = useState('')
    const [selectedSortOption, setSelectedSortOption] = useState('');
    const [mrezaTelefoni, setMrezaTelefoni] = useState('')
    const [telTelefoni, setTelTelefoni] = useState('')
    const [mjestoTelefoni, setMjestoTelefoni] = useState('')
    const [nazivTelefoni, setNazivTelefoni] = useState('')
    const [ulicaTelefoni, setUlicaTelefoni] = useState('')
    const [kbrTelefoni, setKbrTelefoni] = useState('')
    const [slovoTelefoni, setSlovoTelefoni] = useState('')
    const [kbr2Telefoni, setKbr2Telefoni] = useState('')
    const [oibTelefoni, setOibTelefoni] = useState('')
    const [nazivTelefoni2, setNazivTelefoni2] = useState('')
    const [selectedRadioButtonOption, setSelectedRadioButtonOption] = useState('')

    const [selectedRowsDiv1, setSelectedRowsDiv1] = useState([]);
    const [selectedRowsDiv2, setSelectedRowsDiv2] = useState([]);


    const [displayedComponent, setDisplayedComponent] = useState(null);


    const [nazivIliSifraMjesta, setNazivIliSifraMjesta] = useState('')
    const [nazivOpcine, setNazivOpcine] = useState('')
    const [postBrojIliNaziv, setPostBrojIliNaziv] = useState('')
    const [mjestoDiv3, setMjestoDiv3] = useState('')
    const isMenuOpen = useSelector(store=>store.menu?store.menu.open:false)




    const toastError = {                                                        
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
   };

   const toastSuccess = {                                                        
             position: "top-center",
             autoClose: 2000,
             hideProgressBar: false,
             closeOnClick: true,
             pauseOnHover: false,
             draggable: true,
             progress: undefined,
             theme: "light",
   };

   const toastInfo = {                                                        
             position: "top-center",
             autoClose: 2000,
             hideProgressBar: false,
             closeOnClick: true,
             pauseOnHover: false,
             draggable: true,
             progress: undefined,
             theme: "light",
   };
   


    const showDiv1 = () => {
        setDisplayedComponent('div1');
    };

    const showDiv2 = () => {
        setDisplayedComponent('div2');
    };

    const showDiv3 = () => {
        if (selectedListItem != null) {
            setDisplayedComponent('div3');
        }
        else {
            console.log("dont show div 3")
        }
    };

    const [selectedListItem, setSelectedListItem] = useState(null);
    const handleListItemClick = (listItem) => {
        if (selectedListItem === listItem) {
            setSelectedListItem(null)
        } else {
            setSelectedListItem(listItem);
        }
    };

    const [selectedList2Item, setSelectedList2Item] = useState(null);
    const handleList2ItemClick = (listItem) => {
        if (selectedList2Item === listItem) {
            setSelectedList2Item(null)
            setDisplayedComponent(null);
        } else {
            setSelectedList2Item(listItem);
            showDiv3()
        }
    };

    const list2Item = [
        //'MJESTA ULICE\nUpis + Unos\npopul. naziva', //- ne treba
        //'MJESTA ULICE\nbez malih slova',// - ne treba
        'Osobna imena', //- uparena imena
        //'Lista 10 (2014)', //- ne treba
        'ADM promj.šif.', //- šifrarnici provjeri je li dolaze
        'OBRISANE firme', //- treba
        //'DNEVNE statistika',// - ne treba
    ];

useEffect(()=>{
        document.title="Liste"
},[])


    const handleSelectSortChange = (e) => {
        setSelectedSortOption(e.target.value);
    };
    //MOCK DATA
    const sortOptions = ['Option 1', 'Option 2', 'Option 3'];

    const handleRadioButtonOptionClick = (e) => {
        const clickedOption = e.target.value;
        if (selectedRadioButtonOption === clickedOption) {
            // If the same radio button is clicked again, uncheck it
            setSelectedRadioButtonOption("");
        } else {
            // Otherwise, update the selected option
            setSelectedRadioButtonOption(clickedOption);
        }
    };

    //const items = Array.from({ length: 100 }, (item, index) => `Item ${index + 1}`);
    const items = [{no: "00", name: 'Svi podaci o zadanoj firmi'}, //- upisi sifru
        {no: "01", name: 'Firme sa zadanim tekstom u komentaru naslova'},// - upisi tekst
        {no: "02", name: 'Firme bez strukture u bijelima'},// - automatski povuci
       // {no: "03", name: 'Firme koje u nazivu sadrže riječ "VIDI"'},// - automatski povuci
        {no: "04", name: 'Firme koje imaju samo mobilne telefone'}, //- automatski povuci
        {no: "05", name: 'Firme koje nemaju žute stranice'}, //- automatski povuci - omogući desni klik s kopiranom šifrom firme u žutim stranicama otvaranje
        {no: "06", name: 'Firme bez OIB-a'},// - automatski povuci
       // {no: "07", name: 'Svi VIDI-slogovi firmi'}, //- automatski povuci
        {no: "08", name: 'Telefoni iz firmi/žutih kojih nema u buretu'},// - automatski povuci
       // {no: "09", name: 'Svi korisnici (obični i DDI) u Tkc-u'},// - automatski povuci - zanemari/sakrij
        {no: "10", name: 'Pretplatnici s sumnjivim osobnim imenima'}, //- automatski povuci
        {no: "11", name: 'Komentari u Žutim stranicama'},
        {no: "12", name: 'Firme s objavom=7 u naslovu'},
        {no: "13", name: 'Telefoni s nepoznatim mjestom za vaš Tkc'},
        {no: "14", name: 'Telefoni dodijeljeni u krivi TKC zbog pošt.broja'},
        {no: "15", name: 'Telefoni u Donatu koje nema Val'},
        {no: "16", name: 'Bijele stranice zadane firme po cijeloj RH'},
        {no: "17", name: 'Firme s 1. adresom različitom od naslovne'},
        {no: "18", name: 'Osobe s brojem ili navodnikom u imenu i prezimenu'},
        {no: "19", name: 'Telemach - spisak sumnjiva imena'},
        {no: "20", name: 'Telefoni - Donat šalje, bure nema'},// - obavezno
        {no: "21", name: 'Telefoni - T-Mobile šalje, bure nema'},// - obavezno
        {no: "22", name: 'Telefoni - Ostali šalju, bure nema'}, //- obavezno
        {no: "23", name: 'Telefoni - Telemach šalje, bure nema'},// - obavezno
        {no: "24", name: 'Telefoni - A1 šalje, bure nema'}// - obavezno
    ];


    const isprazniPoljaF7ButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("F7")
        setDisplayedComponent(null);
        dispatch(actions.isNotLoading());
    }

    const startF8ButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("F8")
        showDiv2()
        dispatch(actions.isNotLoading());
    }

    const isprazniPoljaF3ButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("F3")
        setDisplayedComponent(null);
        dispatch(actions.isNotLoading());
    }

    const startF4ButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("F4")
        showDiv1()
        dispatch(actions.isNotLoading());
    }



async function getListaBijeleZute () {

/*
    setOperatorStat(false);
    setShowBadData(false);

    setOperatoriTable([],[]);
    setBadData([],[]);
*/

    setCompanyList([],[]);
    setShowCompanyList(false);

    dispatch(actions.isLoading());

    let chosenTKC = 1;
    let chosenMjesto = null;
    let chosenNaziv = 'PERI';


    APICall(
    
        '/searchListeBijeleZute',

        
        {


                tkc: chosenTKC,
                mjesto_id: chosenMjesto,
                naziv: chosenNaziv

            },
        {
            token
        }).then(


            (response) => {
                
                dispatch(actions.isNotLoading());

                if(response==undefined) dispatch(actions.isNotLoading());

                    if(response.status==200){
            
                            if(response.data.list && response.data.list.length!=0){
                                    var dataTmp = response.data;

                                    console.log(dataTmp.list[0]);

                
                                      let columns= Object.getOwnPropertyNames(dataTmp.list[0]).map((column,index)=>{
                                     
                                        var a = column.charAt(0).toUpperCase() + column.slice(1);
                                      
                                
                                        
                                        return(
                                            {
                                                "field": column,
                                                "getRowId": index,
                                                flex:1,
                                                //"width": widthC

                                            
                                            }
                                        )
                                    })



                                    
                                    let rows =dataTmp.list.map((item, index)=> {
                                        return({...item,id:index})
                                    })
                                  

                                    setCompanyList({
                                            columns,
                                            rows
                                    })

                                    setShowCompanyList(true);

                                
                        

                            }else{

        

                                     toast.info("Nisu pronađene tvrtke koje ispunjavaju unešene parametre, molimo provjerite odabrane parametre",
                                         toastError);
                                
                

                                setCompanyList([],[]);
                                setShowCompanyList(false);

                                

                            }
            
                    } else {

                                
                                console.log(response);

                                setCompanyList([],[]);
                                setShowCompanyList(false);

                                if(response.status == 401){

                                        toast.error(response.data.message,
                                            toastError);
                                
                                        setTimeout(() => {
                                            dispatch(actions.logOut());
                                            navigate('/');
                                        }, 5000);   


                                } else {

                                        toast.error(response.data.message, toastError);

                                        
                                }

                    }                        
            
            },

            (error) => {

                dispatch(actions.isNotLoading());

            
                setCompanyList([],[]);
                setShowCompanyList(false);


            
                        if(!error.response){

                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
                            


                        } else {


                                if(!error.response.status){

                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);

                                }else{

                                    if (error.response.status == 401) {
                
                            
                                        toast.error(error.response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   

                                    
                                
                                    } else {
                                
                                
                                            toast.error(error.response.data.message,
                                                    toastError);
                                                                            
                                        
                                    }
                                }
                        }
                    
                    
            
            
            });

            
            
}      



    const listaExcelDiv1ButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("listaExcel")
        dispatch(actions.isNotLoading());
    }

    const drugaMreznaGrupaDiv1ButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("drugaMreznaGrupa")
        dispatch(actions.isNotLoading());
    }

    const novoF12ButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("novoF12")
        dispatch(actions.isNotLoading());
    }

    const listaExcelDiv2ButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("listaExcel")
        dispatch(actions.isNotLoading());
    }

    const drugaMreznaGrupaDiv2ButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("drugaMreznaGrupa")
        dispatch(actions.isNotLoading());
    }

    const krajF12ButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("novoF12")
        dispatch(actions.isNotLoading());
    }

    const brisiDiv3ButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("brisi div3")
        dispatch(actions.isNotLoading());
    }

    const noviDiv3ButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("novi div3")
        dispatch(actions.isNotLoading());
    }

    const krajDiv3ButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("kraj div3")
        dispatch(actions.isNotLoading());
    }

    const novoDiv3F12ButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("novoDiv3")
        dispatch(actions.isNotLoading());
    }

    const okDiv3ButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("ok div 3")
        dispatch(actions.isNotLoading());
    }


    const mockData = [];

    /*const mockData = [
        {
            column1: 'Item 1',
            column2: 'Description 1',
            column3: 10,
            column4: 'Category A',
            column5: 'Vendor X',
            column6: 50.0,
            column7: 'Location A',
            column8: 'In Stock',
            column9: '2023-09-01',
            column10: 'User A',
            column11: 'Notes for Item 1',
            column12: 'Review 1',
            column13: 'Approved',
        },
        {
            column1: 'Item 2',
            column2: 'Description 2',
            column3: 5,
            column4: 'Category B',
            column5: 'Vendor Y',
            column6: 25.0,
            column7: 'Location B',
            column8: 'Out of Stock',
            column9: '2023-09-05',
            column10: 'User B',
            column11: 'Notes for Item 2',
            column12: 'Review 2',
            column13: 'Rejected',
        }, {
            column1: 'Item 1',
            column2: 'Description 1',
            column3: 10,
            column4: 'Category A',
            column5: 'Vendor X',
            column6: 50.0,
            column7: 'Location A',
            column8: 'In Stock',
            column9: '2023-09-01',
            column10: 'User A',
            column11: 'Notes for Item 1',
            column12: 'Review 1',
            column13: 'Approved',
        },
        {
            column1: 'Item 2',
            column2: 'Description 2',
            column3: 5,
            column4: 'Category B',
            column5: 'Vendor Y',
            column6: 25.0,
            column7: 'Location B',
            column8: 'Out of Stock',
            column9: '2023-09-05',
            column10: 'User B',
            column11: 'Notes for Item 2',
            column12: 'Review 2',
            column13: 'Rejected',
        }, {
            column1: 'Item 1',
            column2: 'Description 1',
            column3: 10,
            column4: 'Category A',
            column5: 'Vendor X',
            column6: 50.0,
            column7: 'Location A',
            column8: 'In Stock',
            column9: '2023-09-01',
            column10: 'User A',
            column11: 'Notes for Item 1',
            column12: 'Review 1',
            column13: 'Approved',
        },
        {
            column1: 'Item 2',
            column2: 'Description 2',
            column3: 5,
            column4: 'Category B',
            column5: 'Vendor Y',
            column6: 25.0,
            column7: 'Location B',
            column8: 'Out of Stock',
            column9: '2023-09-05',
            column10: 'User B',
            column11: 'Notes for Item 2',
            column12: 'Review 2',
            column13: 'Rejected',
        }, {
            column1: 'Item 1',
            column2: 'Description 1',
            column3: 10,
            column4: 'Category A',
            column5: 'Vendor X',
            column6: 50.0,
            column7: 'Location A',
            column8: 'In Stock',
            column9: '2023-09-01',
            column10: 'User A',
            column11: 'Notes for Item 1',
            column12: 'Review 1',
            column13: 'Approved',
        },
        {
            column1: 'Item 2',
            column2: 'Description 2',
            column3: 5,
            column4: 'Category B',
            column5: 'Vendor Y',
            column6: 25.0,
            column7: 'Location B',
            column8: 'Out of Stock',
            column9: '2023-09-05',
            column10: 'User B',
            column11: 'Notes for Item 2',
            column12: 'Review 2',
            column13: 'Rejected',
        }, {
            column1: 'Item 1',
            column2: 'Description 1',
            column3: 10,
            column4: 'Category A',
            column5: 'Vendor X',
            column6: 50.0,
            column7: 'Location A',
            column8: 'In Stock',
            column9: '2023-09-01',
            column10: 'User A',
            column11: 'Notes for Item 1',
            column12: 'Review 1',
            column13: 'Approved',
        },
        {
            column1: 'Item 2',
            column2: 'Description 2',
            column3: 5,
            column4: 'Category B',
            column5: 'Vendor Y',
            column6: 25.0,
            column7: 'Location B',
            column8: 'Out of Stock',
            column9: '2023-09-05',
            column10: 'User B',
            column11: 'Notes for Item 2',
            column12: 'Review 2',
            column13: 'Rejected',
        }, {
            column1: 'Item 1',
            column2: 'Description 1',
            column3: 10,
            column4: 'Category A',
            column5: 'Vendor X',
            column6: 50.0,
            column7: 'Location A',
            column8: 'In Stock',
            column9: '2023-09-01',
            column10: 'User A',
            column11: 'Notes for Item 1',
            column12: 'Review 1',
            column13: 'Approved',
        },
        {
            column1: 'Item 2',
            column2: 'Description 2',
            column3: 5,
            column4: 'Category B',
            column5: 'Vendor Y',
            column6: 25.0,
            column7: 'Location B',
            column8: 'Out of Stock',
            column9: '2023-09-05',
            column10: 'User B',
            column11: 'Notes for Item 2',
            column12: 'Review 2',
            column13: 'Rejected',
        }, {
            column1: 'Item 1',
            column2: 'Description 1',
            column3: 10,
            column4: 'Category A',
            column5: 'Vendor X',
            column6: 50.0,
            column7: 'Location A',
            column8: 'In Stock',
            column9: '2023-09-01',
            column10: 'User A',
            column11: 'Notes for Item 1',
            column12: 'Review 1',
            column13: 'Approved',
        },
        {
            column1: 'Item 2',
            column2: 'Description 2',
            column3: 5,
            column4: 'Category B',
            column5: 'Vendor Y',
            column6: 25.0,
            column7: 'Location B',
            column8: 'Out of Stock',
            column9: '2023-09-05',
            column10: 'User B',
            column11: 'Notes for Item 2',
            column12: 'Review 2',
            column13: 'Rejected',
        }
    ];

    */
    const handleRowClickDiv1 = (index) => {
        const selectedIndex = selectedRowsDiv1.indexOf(index);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = [...selectedRowsDiv1, index];
        } else {
            newSelected = [...selectedRowsDiv1.slice(0, selectedIndex), ...selectedRowsDiv1.slice(selectedIndex + 1)];
        }

        setSelectedRowsDiv1(newSelected);
    };

    const handleRowClickDiv2 = (index) => {
        const selectedIndex = selectedRowsDiv2.indexOf(index);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = [...selectedRowsDiv2, index];
        } else {
            newSelected = [...selectedRowsDiv2.slice(0, selectedIndex), ...selectedRowsDiv2.slice(selectedIndex + 1)];
        }

        setSelectedRowsDiv2(newSelected);
    };

    const DivComponent1 = () => {
        return (
            <div className={styles.tableAndButtonContainer}>
                {/*Prvi box*/}
                {/*<div className={styles.tableContainer}>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                  
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 1</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 2</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 3</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 4</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 5</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 6</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 7</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 8</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 9</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 10</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 11</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 12</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 13</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {mockData.map((item, index) => (
                                    <TableRow key={index} onClick={() => handleRowClickDiv1(index)} selected={selectedRowsDiv1.includes(index)}>
                                       
                                        <TableCell style={{ textAlign: 'center' }}>{item.column1}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column2}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column3}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column4}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column5}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column6}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column7}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column8}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column9}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column10}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column11}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column12}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column13}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>*/}

                <div style={{display: 'flex', flexDirection: 'row', marginTop: '30px', alignItems: 'flex-start', 
                justifyContent: 'space-between', width: '100%', height: '200px', 
                        display:companyList.rows? "flex":"none" }}>
                

                        
                        {companyList.rows && <div style={{ width: "100%", height:"100%" , marginTop:10}}> 
                            <AgGridReact
                                rowData={companyList.rows}
                                columnDefs={companyList.columns}
                                

                                ref={gridRef_Comp}
                                theme={themeAG}
                              
                                
                                onGridReady={onGridReady_Comp}
                                onColumnResized={onColumnResized_Comp}


                        />
                        </div> }
                </div> 
             
                <div className={styles.buttonCard}>
                    <div className={styles.mainButtonContainer}>
                        <div className={styles.buttonContainer}>
                            <Button
                            sx={{height:"30px", fontSize:"12px"}}
                                fullWidth
                                variant="contained"
                                onClick={() => {
                                    listaExcelDiv1ButtonFunction()
                                }}
                            >
                                Lista Excel
                            </Button>
                        </div>
                        <div className={styles.buttonContainer}>
                            <Button
                            sx={{height:"30px", fontSize:"12px"}}
                                fullWidth
                                variant="contained"
                                onClick={() => {
                                    drugaMreznaGrupaDiv1ButtonFunction()
                                }}
                            >
                                Druga mrežna grupa
                            </Button>
                        </div>
                        <div className={styles.buttonContainer}>
                            <div style={{ display: 'flex', width: '100%', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                <p style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                    Za detalje, kliknite na firm
                                </p>
                            </div>
                        </div>
                        <div className={styles.buttonContainer}>
                            <Button
                            sx={{height:"30px", fontSize:"12px"}}
                                fullWidth
                                variant="contained"
                                onClick={() => {
                                    novoF12ButtonFunction()
                                }}
                            >
                                NOVO 
                            </Button>
                        </div>
                    </div>
                </div>

            </div>
        )
    }

    const DivComponent2 = () => {
        return (
            <div className={styles.tableAndButtonContainer}>
                {/*Prvi box*/}
                <div className={styles.tableContainer}>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    {/* Define your table headers here */}
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 1</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 2</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 3</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 4</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 5</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 6</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 7</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 8</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 9</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 10</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 11</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 12</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 13</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {mockData.map((item, index) => (
                                    <TableRow key={index} onClick={() => handleRowClickDiv2(index)} selected={selectedRowsDiv2.includes(index)}>
                                        {/* Map your data to the table rows */}
                                        <TableCell style={{ textAlign: 'center' }}>{item.column1}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column2}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column3}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column4}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column5}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column6}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column7}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column8}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column9}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column10}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column11}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column12}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column13}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>

                {/*Botuni box*/}
                <div className={styles.buttonCard}>
                    <div className={styles.mainButtonContainer}>
                        <div className={styles.buttonContainer}>
                            <Button
                            sx={{height:"30px", fontSize:"12px"}}
                                fullWidth
                                variant="contained"
                                onClick={() => {
                                    listaExcelDiv2ButtonFunction()
                                }}
                            >
                                Lista Excel
                            </Button>
                        </div>
                        <div className={styles.buttonContainer}>
                            <Button
                            sx={{height:"30px", fontSize:"12px"}}
                                fullWidth
                                variant="contained"
                                onClick={() => {
                                    drugaMreznaGrupaDiv2ButtonFunction()
                                }}
                            >
                                Druga mrežna grupa
                            </Button>
                        </div>
                        <div className={styles.buttonContainer}>
                            <div style={{ display: 'flex', width: '100%', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                <p style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                    (nema detalja)
                                </p>
                            </div>
                        </div>
                        <div className={styles.buttonContainer}>
                            <Button
                                fullWidth
                                variant="contained"
                                onClick={() => {
                                    krajF12ButtonFunction()
                                }}
                            >
                                KRAJ 
                            </Button>
                        </div>
                    </div>
                </div>

            </div>
        )
    }

    const DivComponent3 = () => {
        return (
            <>
                {/*container1*/}
                <div className={styles.container}>

                    {/*Prvi box*/}
                    <div className={styles.div3CardContainerLeft}>

                        {/*Opis 1*/}
                        <div style={{ display: 'flex', width: '90%', justifyContent: 'center', alignItems: 'center' }}>
                            <div style={{ display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                <p style={{ fontWeight: 'bold'}}>
                                    UPIT - MJESTA I ULICE:
                                </p>
                                <p>
                                    Korekcija malih/velikih slova
                                </p>
                            </div>
                        </div>

                        {/*Prvi red*/}
                        <div className={styles.redContainerDiv}>
                            <div className={styles.box1Row1Div1}>
                                <TextField
                                    fullWidth
                                    id="nazivIliSifraMjesta"
                                    label="Naziv ili šifra mjesta"
                                    variant="outlined"
                                    value={nazivIliSifraMjesta}
                                    onChange={(event) => {
                                        setNazivIliSifraMjesta(event.target.value);
                                    }}
                                />
                            </div>
                            <div className={styles.box1Row1Div1}>
                                <TextField
                                    fullWidth
                                    id="nazivOpcine"
                                    label="Naziv općine"
                                    variant="outlined"
                                    value={nazivOpcine}
                                    onChange={(event) => {
                                        setNazivOpcine(event.target.value);
                                    }}
                                />
                            </div>
                            <div className={styles.box1Row1Div1}>
                                <TextField
                                    fullWidth
                                    id="postBrojIliNaziv"
                                    label="Pošt. broj ili naziv"
                                    variant="outlined"
                                    value={postBrojIliNaziv}
                                    onChange={(event) => {
                                        setPostBrojIliNaziv(event.target.value);
                                    }}
                                />
                            </div>
                            <div className={styles.box1Row1Div2}>
                                <TextField
                                    fullWidth
                                    id="mjestoDiv3"
                                    label="Mjesto"
                                    variant="outlined"
                                    value={mjestoDiv3}
                                    onChange={(event) => {
                                        setMjestoDiv3(event.target.value);
                                    }}
                                />
                            </div>

                            <div className={styles.buttonContainer}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    onClick={() => {
                                        okDiv3ButtonFunction()
                                    }}
                                >
                                    OK
                                </Button>
                            </div>

                        </div>

                        {/*Drugi red*/}
                        <div className={styles.redContainerDiv}>
                            <div className={styles.tableContainerDiv3}>
                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                {/* Define your table headers here */}
                                                <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 1</TableCell>
                                                <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 2</TableCell>
                                                <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 3</TableCell>
                                                <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 4</TableCell>
                                                <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 5</TableCell>
                                                <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 6</TableCell>
                                                <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 7</TableCell>
                                                <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 8</TableCell>
                                                <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 9</TableCell>
                                                <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 10</TableCell>
                                                <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 11</TableCell>
                                                <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 12</TableCell>
                                                <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 13</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {mockData.map((item, index) => (
                                                <TableRow key={index} onClick={() => handleRowClickDiv2(index)} selected={selectedRowsDiv2.includes(index)}>
                                                    {/* Map your data to the table rows */}
                                                    <TableCell style={{ textAlign: 'center' }}>{item.column1}</TableCell>
                                                    <TableCell style={{ textAlign: 'center' }}>{item.column2}</TableCell>
                                                    <TableCell style={{ textAlign: 'center' }}>{item.column3}</TableCell>
                                                    <TableCell style={{ textAlign: 'center' }}>{item.column4}</TableCell>
                                                    <TableCell style={{ textAlign: 'center' }}>{item.column5}</TableCell>
                                                    <TableCell style={{ textAlign: 'center' }}>{item.column6}</TableCell>
                                                    <TableCell style={{ textAlign: 'center' }}>{item.column7}</TableCell>
                                                    <TableCell style={{ textAlign: 'center' }}>{item.column8}</TableCell>
                                                    <TableCell style={{ textAlign: 'center' }}>{item.column9}</TableCell>
                                                    <TableCell style={{ textAlign: 'center' }}>{item.column10}</TableCell>
                                                    <TableCell style={{ textAlign: 'center' }}>{item.column11}</TableCell>
                                                    <TableCell style={{ textAlign: 'center' }}>{item.column12}</TableCell>
                                                    <TableCell style={{ textAlign: 'center' }}>{item.column13}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </div>

                        {/*Treci red*/}
                        <div className={styles.redContainerDiv3}>
                            <div className={styles.tableContainerDiv3Row3Left}>
                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                {/* Define your table headers here */}
                                                <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 1</TableCell>
                                                <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 2</TableCell>
                                                <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 3</TableCell>
                                                <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 4</TableCell>
                                                <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 5</TableCell>
                                                <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 6</TableCell>
                                                <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 7</TableCell>
                                                <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 8</TableCell>
                                                <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 9</TableCell>
                                                <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 10</TableCell>
                                                <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 11</TableCell>
                                                <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 12</TableCell>
                                                <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 13</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {mockData.map((item, index) => (
                                                <TableRow key={index} onClick={() => handleRowClickDiv2(index)} selected={selectedRowsDiv2.includes(index)}>
                                                    {/* Map your data to the table rows */}
                                                    <TableCell style={{ textAlign: 'center' }}>{item.column1}</TableCell>
                                                    <TableCell style={{ textAlign: 'center' }}>{item.column2}</TableCell>
                                                    <TableCell style={{ textAlign: 'center' }}>{item.column3}</TableCell>
                                                    <TableCell style={{ textAlign: 'center' }}>{item.column4}</TableCell>
                                                    <TableCell style={{ textAlign: 'center' }}>{item.column5}</TableCell>
                                                    <TableCell style={{ textAlign: 'center' }}>{item.column6}</TableCell>
                                                    <TableCell style={{ textAlign: 'center' }}>{item.column7}</TableCell>
                                                    <TableCell style={{ textAlign: 'center' }}>{item.column8}</TableCell>
                                                    <TableCell style={{ textAlign: 'center' }}>{item.column9}</TableCell>
                                                    <TableCell style={{ textAlign: 'center' }}>{item.column10}</TableCell>
                                                    <TableCell style={{ textAlign: 'center' }}>{item.column11}</TableCell>
                                                    <TableCell style={{ textAlign: 'center' }}>{item.column12}</TableCell>
                                                    <TableCell style={{ textAlign: 'center' }}>{item.column13}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>

                            <div className={styles.tableAndButtonContainerDiv3}>
                                <div className={styles.tableContainerDiv3Row3Right}>
                                    <TableContainer>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    {/* Define your table headers here */}
                                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 1</TableCell>
                                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 2</TableCell>
                                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 3</TableCell>
                                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 4</TableCell>
                                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 5</TableCell>
                                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 6</TableCell>
                                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 7</TableCell>
                                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 8</TableCell>
                                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 9</TableCell>
                                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 10</TableCell>
                                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 11</TableCell>
                                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 12</TableCell>
                                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 13</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {mockData.map((item, index) => (
                                                    <TableRow key={index} onClick={() => handleRowClickDiv2(index)} selected={selectedRowsDiv2.includes(index)}>
                                                        {/* Map your data to the table rows */}
                                                        <TableCell style={{ textAlign: 'center' }}>{item.column1}</TableCell>
                                                        <TableCell style={{ textAlign: 'center' }}>{item.column2}</TableCell>
                                                        <TableCell style={{ textAlign: 'center' }}>{item.column3}</TableCell>
                                                        <TableCell style={{ textAlign: 'center' }}>{item.column4}</TableCell>
                                                        <TableCell style={{ textAlign: 'center' }}>{item.column5}</TableCell>
                                                        <TableCell style={{ textAlign: 'center' }}>{item.column6}</TableCell>
                                                        <TableCell style={{ textAlign: 'center' }}>{item.column7}</TableCell>
                                                        <TableCell style={{ textAlign: 'center' }}>{item.column8}</TableCell>
                                                        <TableCell style={{ textAlign: 'center' }}>{item.column9}</TableCell>
                                                        <TableCell style={{ textAlign: 'center' }}>{item.column10}</TableCell>
                                                        <TableCell style={{ textAlign: 'center' }}>{item.column11}</TableCell>
                                                        <TableCell style={{ textAlign: 'center' }}>{item.column12}</TableCell>
                                                        <TableCell style={{ textAlign: 'center' }}>{item.column13}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>




                                </div>

                                <div className={styles.mainButtonContainerDiv3Row3}>
                                    <div className={styles.buttonContainer}>
                                        <Button
                                            fullWidth
                                            variant="contained"
                                            onClick={() => {
                                                brisiDiv3ButtonFunction()
                                            }}
                                        >
                                            Briši
                                        </Button>
                                    </div>
                                    <div className={styles.buttonContainer}>
                                        <Button
                                            fullWidth
                                            variant="contained"
                                            onClick={() => {
                                                noviDiv3ButtonFunction()
                                            }}
                                        >
                                            Novi
                                        </Button>
                                    </div>
                                    <div className={styles.buttonContainer}>
                                        <Button
                                            fullWidth
                                            variant="contained"
                                            onClick={() => {
                                                krajDiv3ButtonFunction()
                                            }}
                                        >
                                            KRAJ
                                        </Button>
                                    </div>
                                </div>
                            </div>



                        </div>


                    </div>

                    {/*Drugi box*/}
                    <div className={styles.div3CardContainerRight}>

                        {/*Table*/}
                        <div className={styles.tableContainerDiv3RightTable}>
                            <TableContainer>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            {/* Define your table headers here */}
                                            <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 1</TableCell>
                                            <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 2</TableCell>
                                            <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 3</TableCell>
                                            <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 4</TableCell>
                                            <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 5</TableCell>
                                            <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 6</TableCell>
                                            <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 7</TableCell>
                                            <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 8</TableCell>
                                            <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 9</TableCell>
                                            <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 10</TableCell>
                                            <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 11</TableCell>
                                            <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 12</TableCell>
                                            <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 13</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {mockData.map((item, index) => (
                                            <TableRow key={index} onClick={() => handleRowClickDiv2(index)} selected={selectedRowsDiv2.includes(index)}>
                                                {/* Map your data to the table rows */}
                                                <TableCell style={{ textAlign: 'center' }}>{item.column1}</TableCell>
                                                <TableCell style={{ textAlign: 'center' }}>{item.column2}</TableCell>
                                                <TableCell style={{ textAlign: 'center' }}>{item.column3}</TableCell>
                                                <TableCell style={{ textAlign: 'center' }}>{item.column4}</TableCell>
                                                <TableCell style={{ textAlign: 'center' }}>{item.column5}</TableCell>
                                                <TableCell style={{ textAlign: 'center' }}>{item.column6}</TableCell>
                                                <TableCell style={{ textAlign: 'center' }}>{item.column7}</TableCell>
                                                <TableCell style={{ textAlign: 'center' }}>{item.column8}</TableCell>
                                                <TableCell style={{ textAlign: 'center' }}>{item.column9}</TableCell>
                                                <TableCell style={{ textAlign: 'center' }}>{item.column10}</TableCell>
                                                <TableCell style={{ textAlign: 'center' }}>{item.column11}</TableCell>
                                                <TableCell style={{ textAlign: 'center' }}>{item.column12}</TableCell>
                                                <TableCell style={{ textAlign: 'center' }}>{item.column13}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>

                        {/*Buttons*/}
                        <div className={styles.mainButtonContainerDiv3Right}>
                            <div className={styles.buttonContainer}>
                                <div className={styles.buttonContainer}>
                                    <div style={{ display: 'flex', width: '100%', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-end' }}>
                                        <p style={{ textAlign: 'center', fontSize: '15px' }}>
                                            Za detalje, kliknite na firm
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.buttonContainer}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    onClick={() => {
                                        novoDiv3F12ButtonFunction()
                                    }}
                                >
                                    Novo 
                                </Button>
                            </div>
                        </div>

                    </div>




                </div>


            </>
        )
    }


    return (
        <ThemeProvider theme={theme}>
            <div className={styles.mainContainer}>

                {/*container1*/}
                <div className={styles.container}>

                    {/*Prvi box*/}
                    <div className={styles.cardContainer}>

                        {/*Opis 1*/}
                        <div style={{ display: 'flex', width: '90%', justifyContent: 'center', alignItems: 'center' }}>
                            <div style={{ marginBottom: "10px", marginTop: "10px",display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                <p style={{ fontWeight: 'bold'}}>
                                    UPIT - VAL:
                                </p>
                                <p>
                                    (Bijele i žute forme)
                                </p>
                            </div>
                        </div>

                        {/*Prvi red*/}
                        <div className={styles.redContainerDiv}>
                            <div className={styles.box1Row1Div1}>
                                <TextField
                                    fullWidth
                                    id="sifraFirme"
                                    label="Šifra firme"
                                    variant="outlined"
                                    value={sifraFirme}
                                    onChange={(event) => {
                                        setSifraFirme(event.target.value);
                                    }}
                                />
                            </div>
                            <div className={styles.box1Row1Div2}>
                                <TextField
                                    fullWidth
                                    id="pojam"
                                    label="Pojam"
                                    variant="outlined"
                                    value={pojam}
                                    onChange={(event) => {
                                        setPojam(event.target.value);
                                    }}
                                />
                            </div>
                        </div>

                        {/*Drugi red*/}
                        <div className={styles.redContainerDiv}>
                            <div style={{ width: '100%' }}>
                                <TextField
                                    fullWidth
                                    id="mjesto"
                                    label="Mjesto"
                                    variant="outlined"
                                    value={mjesto}
                                    onChange={(event) => {
                                        setMjesto(event.target.value);
                                    }}
                                />
                            </div>
                        </div>

                        {/*Treci red*/}
                        <div className={styles.redContainerDiv}>
                            <div style={{ width: '100%' }}>
                                <TextField
                                    fullWidth
                                    id="nazivFirme"
                                    label="Naziv firme"
                                    variant="outlined"
                                    value={nazivFirme}
                                    onChange={(event) => {
                                        setNazivFirme(event.target.value);
                                    }}
                                />
                            </div>
                        </div>

                        {/*Cetvrti red*/}
                        <div className={styles.redContainerDiv}>
                            <div style={{ width: '100%' }}>
                                <TextField
                                    fullWidth
                                    id="nazivStru"
                                    label="Naziv stru"
                                    variant="outlined"
                                    value={nazivStru}
                                    onChange={(event) => {
                                        setNazivStru(event.target.value);
                                    }}
                                />
                            </div>
                        </div>

                        {/*Peti red*/}
                        <div className={styles.redContainerDiv}>
                            <div className={styles.box1Row5Div1}>
                                <TextField
                                    fullWidth
                                    id="matBroj"
                                    label="Mat. broj"
                                    variant="outlined"
                                    value={matBroj}
                                    onChange={(event) => {
                                        setMatBroj(event.target.value);
                                    }}
                                />
                            </div>
                            <div className={styles.box1Row5Div2}>
                                <div style={{ width: '30%' }}>
                                    <TextField
                                        fullWidth
                                        id="tel1"
                                        label="Tel"
                                        variant="outlined"
                                        value={tel1}
                                        onChange={(event) => {
                                            setTel1(event.target.value);
                                        }}
                                    />
                                </div>

                                <div style={{ width: '70%' }}>
                                    <TextField
                                        fullWidth
                                        id="tel2"
                                        label=""
                                        variant="outlined"
                                        value={tel2}
                                        onChange={(event) => {
                                            setTel2(event.target.value);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        {/*Sesti red*/}
                        <div className={styles.redContainerDiv}>
                            <div style={{ width: '100%' }}>
                                <TextField
                                    fullWidth
                                    id="ulica"
                                    label="Ulica"
                                    variant="outlined"
                                    value={ulica}
                                    onChange={(event) => {
                                        setUlica(event.target.value);
                                    }}
                                />
                            </div>
                        </div>

                        {/*Sedmi red*/}
                        <div className={styles.redContainerDiv}>
                            <div className={styles.box1Row7Div1}>
                                <div style={{ width: '50%' }}>
                                    <TextField
                                        fullWidth
                                        id="kbrSlovo1"
                                        label="Kbr/Slovo"
                                        variant="outlined"
                                        value={kbrSlovo1}
                                        onChange={(event) => {
                                            setKbrSlovo1(event.target.value);
                                        }}
                                    />
                                </div>

                                <div style={{ width: '50%' }}>
                                    <TextField
                                        fullWidth
                                        id="kbrSlovo2"
                                        label=""
                                        variant="outlined"
                                        value={kbrSlovo2}
                                        onChange={(event) => {
                                            setKbrSlovo2(event.target.value);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        {/*Sedmi red*/}
                        <div className={styles.redContainerDiv}>

                            <div className={styles.box1Row7Div2}>
                                <TextField
                                    fullWidth
                                    id="kbr2"
                                    label="Kbr2"
                                    variant="outlined"
                                    value={kbr2}
                                    onChange={(event) => {
                                        setKbr2(event.target.value);
                                    }}
                                />
                            </div>

                            <div className={styles.box1Row7Div3}>
                                <TextField
                                    fullWidth
                                    id="oib"
                                    label="OIB"
                                    variant="outlined"
                                    value={oib}
                                    onChange={(event) => {
                                        setOib(event.target.value);
                                    }}
                                />
                            </div>
                        </div>

                        {/*Osmi red*/}
                        <div className={styles.redContainerDiv}>
                            <div className={styles.box1Row8Div1}>
                                <TextField
                                    fullWidth
                                    id="djelatnost"
                                    label="Djelatnost"
                                    variant="outlined"
                                    value={djelatnost}
                                    onChange={(event) => {
                                        setDjelatnost(event.target.value);
                                    }}
                                />
                            </div>

                            <div className={styles.box1Row8Div2}>
                                <FormControl fullWidth>
                                    <InputLabel id="sort">Sort</InputLabel>
                                    <Select
                                        labelId="sort"
                                        id="sort-select"
                                        value={selectedSortOption}
                                        label="Sort"
                                        onChange={handleSelectSortChange}
                                    >
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        {sortOptions.map((option, index) => (
                                            <MenuItem key={index} value={option}>
                                                {option}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>

                        </div>

                        {/*Deveeti red*/}
                        <div className={styles.buttonContainerDiv}>
                            <div className={styles.box2Row9Div1}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    onClick={() => {
                                        isprazniPoljaF3ButtonFunction()
                                    }}
                                >
                                    Isprazni polja
                                </Button>

                            </div>
                            <div className={styles.box2Row9Div2}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    onClick={() => {
                                        //startF4ButtonFunction()
                                        getListaBijeleZute();
                                    }}
                                >
                                    Start
                                </Button>
                            </div>
                        </div>




                    </div>

                    {/*Drugi box*/}
                    <div className={styles.cardContainer}>
                        {/*Opis 1*/}
                        <div style={{ display: 'flex', width: '90%', justifyContent: 'center', alignItems: 'center',  }}>
                            <div style={{ marginBottom: "10px",display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginBottom: "15px" }}>
                                <p style={{ fontWeight: 'bold'}}>
                                    UPIT - TELEFONI: 
                                </p>
                                <p>
                                    (Donat, Mobilne, Korisnici)
                                </p>
                            </div>
                        </div>

                        {/*Prvi red*/}
                        <div className={styles.redContainerDiv}>
                            <div className={styles.box1Row1Div1}>
                                <TextField
                                    fullWidth
                                    id="mrezaTelefoni"
                                    label="Mreža"
                                    variant="outlined"
                                    value={mrezaTelefoni}
                                    onChange={(event) => {
                                        setMrezaTelefoni(event.target.value);
                                    }}
                                />
                            </div>
                            <div className={styles.box1Row1Div2}>
                                <TextField
                                    fullWidth
                                    id="telTelefoni"
                                    label="Tel"
                                    variant="outlined"
                                    value={telTelefoni}
                                    onChange={(event) => {
                                        setTelTelefoni(event.target.value);
                                    }}
                                />
                            </div>
                        </div>

                        {/*Drugi red*/}
                        <div className={styles.redContainerDiv}>
                            <div style={{ width: '100%' }}>
                                <TextField
                                    fullWidth
                                    id="mjestoTelefoni"
                                    label="Mjesto"
                                    variant="outlined"
                                    value={mjestoTelefoni}
                                    onChange={(event) => {
                                        setMjestoTelefoni(event.target.value);
                                    }}
                                />
                            </div>
                        </div>

                        {/*Treci red*/}
                        <div className={styles.redContainerDiv}>
                            <div style={{ width: '100%' }}>
                                <TextField
                                    fullWidth
                                    id="nazivTelefoni"
                                    label="Naziv"
                                    variant="outlined"
                                    value={nazivTelefoni}
                                    onChange={(event) => {
                                        setNazivTelefoni(event.target.value);
                                    }}
                                />
                            </div>
                        </div>

                        {/*Cetvrti red*/}
                        <div className={styles.redContainerDiv}>
                            <div style={{ width: '100%' }}>
                                <TextField
                                    fullWidth
                                    id="nazivTelefoni2"
                                    label="Naziv2"
                                    variant="outlined"
                                    value={nazivTelefoni2}
                                    onChange={(event) => {
                                        setNazivTelefoni2(event.target.value);
                                    }}
                                />
                            </div>
                        </div>

                        {/*Peti red*/}
                        <div className={styles.redContainerDiv}>
                            <div style={{ width: '100%' }}>
                                <TextField
                                    fullWidth
                                    id="ulicaTelefoni"
                                    label="Ulica"
                                    variant="outlined"
                                    value={ulicaTelefoni}
                                    onChange={(event) => {
                                        setUlicaTelefoni(event.target.value);
                                    }}
                                />
                            </div>
                        </div>

                        {/*Sesti red*/}
                        <div className={styles.redContainerDiv}>
                            <div className={styles.box2Row6Div1}>
                                <TextField
                                    fullWidth
                                    id="kbrTelefoni"
                                    label="Kbr"
                                    variant="outlined"
                                    value={kbrTelefoni}
                                    onChange={(event) => {
                                        setKbrTelefoni(event.target.value);
                                    }}
                                />
                            </div>
                            <div className={styles.box2Row6Div2}>
                                <TextField
                                    fullWidth
                                    id="slovoTelefoni"
                                    label="Slovo"
                                    variant="outlined"
                                    value={slovoTelefoni}
                                    onChange={(event) => {
                                        setSlovoTelefoni(event.target.value);
                                    }}
                                />
                            </div>
                            <div className={styles.box2Row6Div3}>
                                <TextField
                                    fullWidth
                                    id="kbr2Telefoni"
                                    label="Kbr2"
                                    variant="outlined"
                                    value={kbr2Telefoni}
                                    onChange={(event) => {
                                        setKbr2Telefoni(event.target.value);
                                    }}
                                />
                            </div>
                        </div>



                        {/*Sedmi red*/}
                        <div className={styles.redContainerDiv}>
                            <div style={{ width: '100%' }}>
                                <TextField
                                    fullWidth
                                    id="oibTelefoni"
                                    label="OIB"
                                    variant="outlined"
                                    value={oibTelefoni}
                                    onChange={(event) => {
                                        setOibTelefoni(event.target.value);
                                    }}
                                />
                            </div>
                        </div>

                        {/*Osmi red*/}
                        <div className={styles.redContainerDiv}>
                            <div style={{ flex: 1, width: '100%', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                <FormControl fullWidth>
                                    <RadioGroup
                                        aria-labelledby="group"
                                        row
                                        name="radio-buttons-group"
                                        onClick={handleRadioButtonOptionClick}
                                        value={selectedRadioButtonOption}
                                    >
                                        <FormControlLabel value="Option 1" control={<Radio />} label="Osobe" />
                                        <FormControlLabel value="Option 2" control={<Radio />} label="Obrt" />
                                        <FormControlLabel value="Option 3" control={<Radio />} label="Oboje" />
                                        <FormControlLabel value="Option 4" control={<Radio />} label="Firme" />
                                        <FormControlLabel value="Option 5" control={<Radio />} label="Sve" />
                                    </RadioGroup>
                                </FormControl>
                            </div>

                        </div>

                        {/*Deveeti red*/}
                        <div className={styles.buttonContainerDiv}>
                            <div className={styles.box2Row9Div1}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    onClick={() => {
                                        isprazniPoljaF7ButtonFunction()
                                    }}
                                >
                                    Isprazni polja 
                                </Button>

                            </div>
                            <div className={styles.box2Row9Div2}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    onClick={() => {
                                        startF8ButtonFunction()
                                    }}
                                >
                                    Start 
                                </Button>
                            </div>
                        </div>


                    </div>

                    {/*Treci box*/}
                    <div className={styles.cardContainer}>

                        {/*Opis 1*/}
                        <div style={{ display: 'flex', width: '90%', justifyContent: 'center', alignItems: 'center' }}>
                            <div style={{ display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                <p style={{ fontWeight: 'bold'}}>
                                    LISTE:
                                </p>
                            </div>
                        </div>


                        {/*LIST OF DATA*/}
                        <div className={styles.listContainerDiv}>
                            <List>
                                {items.map((item, index) => (
                                    <ListItemButton
                                        key={index}
                                        onClick={() => handleListItemClick(item)}
                                        style={{
                                            backgroundColor: selectedListItem === item ? theme.palette.primary.light : 'white',
                                            color: selectedListItem === item ? 'white' : 'black',
                                        }}
                                    >
                                        <ListItemText primary={item.name} style={{ textAlign: 'center' }} />
                                    </ListItemButton>
                                ))}
                            </List>
                        </div>


                    </div>

                    {/*Desni box upute*/}
                    <div className={styles.uputeBoxContainer}>
                        {/*UPUTE*/}
                        {/*<div className={styles.uputeBox1ButtonColumn}>
                            <Button
                                fullWidth
                                variant="contained"
                                onClick={() => {
                                    isprazniPoljaF7ButtonFunction()
                                }}
                            >
                                MEMO - obrišiiiiiii
                            </Button>
                        </div>*/}

                        <List>
                            {list2Item.map((item, index) => (
                                <ListItemButton
                                    key={index}
                                    onClick={() => handleList2ItemClick(item)}
                                    style={{
                                        backgroundColor: selectedList2Item === item ? theme.palette.primary.light : 'white',
                                        color: selectedList2Item === item ? 'white' : 'black',
                                        borderBottom: selectedList2Item === item ? 'white' : '2px solid #000',
                                    }}
                                >
                                    <ListItemText primary={item} style={{ textAlign: 'center' }} />
                                </ListItemButton>
                            ))}
                        </List>


                    </div>


                </div>


            
                {showCompanyList && <DivComponent1 />}

          
                {displayedComponent === 'div2' && <DivComponent2 />}

          
                {displayedComponent === 'div3' && <DivComponent3 />} 

            </div>
        </ThemeProvider>

    )
}

export default TelefonskiImenik;

